export enum Stage {
  LEARNING = "learningStage",
  MONITORING = "monitoringStage",
  BUSINESS_PLAN = "businessPlanStage",
}
